import { Title } from "playbook-ui";

const PbTitle = Title;

export default PbTitle